/**
 * @deprecated This legacy token system is deprecated and will be removed in a future version.
 *
 * Migration path:
 * - Use Tailwind utility classes with the modern `ds-*` prefix (e.g., `bg-ds-bg-card`, `text-ds-text-primary`)
 * - Or import from `src/design/tokens.ts` for programmatic access
 *
 * Modern token system:
 * - Tailwind config: Uses CSS variables and `ds-*` prefixed colors
 * - Design tokens: `src/design/tokens.ts` (comprehensive design system)
 * - CSS variables: `src/index.css` (supports theming and dark mode)
 *
 * See SETTINGS_COMPONENTS.md for migration guidance.
 */

export const colors = {
  text: '#1E1E2D',
  muted: '#6B7280',
  primary: '#16A34A',
  primaryHover: '#15803D',
  secondary: '#E4E6EF',
  accent: '#16A34A',
  background: '#F5F6FA',        // Light gray background like BankHub
  neutral: '#F8F9FA',           // Slightly lighter gray
  surface: '#FFFFFF',           // Pure white for cards/surfaces
  overlay: 'rgba(0,0,0,0.4)',
  border: '#E5E7EB',
  gray100: '#F3F4F6',
  gray50: '#F9FAFB',
  unitBlue: '#dbeafe',
  unitGreen: '#d1fae5',
  unitOrange: '#ffedd5',
  unitRed: '#fee2e2',
  unitPurple: '#ede9fe',
  red50: '#fef2f2',
  red600: '#dc2626',
  blue50: '#eff6ff',
  blue800: '#1e40af',
  yellow50: '#fefce8',
  yellow800: '#854d0e',
  green50: '#f0fdf4',
  green800: '#166534',
  error: '#DC2626',
  success: '#16A34A',
  mutedText: '#6B7280',
  hover: '#F3F4F6',
  card: '#FFFFFF',                // Pure white for cards
  sidebar: '#FFFFFF',             // Pure white sidebar
};

export const typography = {
  fontFamily: 'Inter, sans-serif',
  fontSizeBase: '14px',
  fontWeightBold: 700,
};

export const spacing = {
  xs: '0.25rem',
  sm: '0.5rem',
  md: '1rem',
  lg: '1.5rem',
  xl: '2rem',
};

export const radius = {
  sm: '0.125rem',
  md: '0.375rem',
  lg: '0.5rem',
  full: '9999px',
};

export const shadows = {
  sm: '0 1px 2px rgba(0,0,0,0.05)',
  md: '0 4px 6px rgba(0,0,0,0.1)',
  lg: '0 10px 15px rgba(0,0,0,0.1)',
};

export const theme = {
  colors,
  typography,
  spacing,
  radius,
  shadows,
};

export default theme;
